import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import ParentSidebar from './ParentSidebar';
import { getPageInfo } from '../../utils/sideBarHelpers';
import ParentHeader from '../dashboard/layout/parentHeader';

const ParentDashboardLayout = ({ children }) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [searchQuery, setSearchQuery] = useState(urlParams.get('search') || '');

  const { title, subtitle } = getPageInfo(location.pathname);

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };
  return (
    <div className="bg-[#F4F2F9] h-lvh overflow-hidden flex">
      <ParentSidebar />

      <div className="overflow-y-scroll relative w-full">
        <ParentHeader
          searchQuery={searchQuery}
          setSearchQuery={handleSearchChange}
          title={title}
          subtitle={subtitle}
        />

        <Outlet />
      </div>
    </div>
  );
};

export default ParentDashboardLayout;
